<template>
  <router-view></router-view>
  
</template>

<script>

export default {
  name: "App",

  mounted() {
    // let scriptChat = document.createElement("script");
    // scriptChat.setAttribute("src", "https://embed.tawk.to/64de1bb594cf5d49dc6af4a2/1h81pofph");
    // scriptChat.charset='UTF-8'
    // scriptChat.setAttribute('crossorigin','*');
    // document.head.appendChild(scriptChat);
  },
};
</script>

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";
.modal-content .modal-footer {
  display: none !important;
}



</style>
